var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8598_11954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39777 5.67209L3.36027 0.956466C3.34449 0.944046 3.32553 0.936327 3.30557 0.934197C3.2856 0.932066 3.26544 0.93561 3.2474 0.944421C3.22936 0.953232 3.21417 0.966953 3.20357 0.984009C3.19298 1.00106 3.18741 1.02076 3.1875 1.04084V2.07611C3.1875 2.14173 3.2183 2.20468 3.2692 2.24486L8.09063 6.00959L3.2692 9.77432C3.21697 9.8145 3.1875 9.87745 3.1875 9.94307V10.9783C3.1875 11.0681 3.29063 11.1176 3.36027 11.0627L9.39777 6.34709C9.44908 6.30706 9.4906 6.25586 9.51915 6.19738C9.5477 6.1389 9.56254 6.07467 9.56254 6.00959C9.56254 5.94451 9.5477 5.88029 9.51915 5.8218C9.4906 5.76332 9.44908 5.71212 9.39777 5.67209Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8598_11954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.66f267f19bf3ed4e07a3ec7720f19a20.svg";
export { ForwardRef as ReactComponent };